module.exports = __webpack_public_path__ + "e297e895814ef6c19ef76dde1fb3275d.png";